import { render, staticRenderFns } from "./beij.vue?vue&type=template&id=d65e26e6&"
import script from "./beij.vue?vue&type=script&lang=js&"
export * from "./beij.vue?vue&type=script&lang=js&"
import style0 from "./beij.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports